module.exports = __webpack_public_path__ + "static/media/menu.346782d5.svg";